module.exports = __webpack_public_path__ + "media/RandomCat1.6cd31a85.png";